var map = {
	"./clouds-night.png": "17d5",
	"./clouds.png": "d00b",
	"./haze.png": "b3ef",
	"./light-rain.png": "9f91",
	"./light-snow.png": "766b",
	"./moisture.png": "3f76",
	"./moon-stars.png": "94c0",
	"./partly-cloudy.png": "11f9",
	"./snow-storm.png": "f9c3",
	"./sun.png": "f8f9",
	"./unknown.png": "396b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5827";